import { render, staticRenderFns } from "./message-info.vue?vue&type=template&id=ac40e7ea&scoped=true"
import script from "./message-info.vue?vue&type=script&lang=js"
export * from "./message-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac40e7ea",
  null
  
)

export default component.exports